export default {
  ONLINE_EDUCATION: `ONLINE_EDUCATION`,
  E_COMMERCE: `E_COMMERCE`,
  LOGISTICS: `LOGISTICS`,
  ONLINE_SERVICE: `ONLINE_SERVICE`,
  CONSULTING: `CONSULTING`,
  ADVERTISING: `ADVERTISING`,
  TECH: `TECH`,
  FINE_TECH: `FINE_TECH`,
  PERSONAL_BUSINESS: `PERSONAL_BUSINESS`,
  MANUFACTURING: `MANUFACTURING`,
  CONTRACTING: `CONTRACTING`,
  TRADE: `TRADE`,
  MIGRATION: `MIGRATION`,
  SERVICES: `SERVICES`,
  OTHERS: `OTHERS`,
};
